<template>
  <v-dialog 
    v-model="dialog" 
    width="600" 
    content-class="aboutUs"
  >
    <v-card>
      <v-btn icon absolute right top @click="dialog = false">
        <v-icon>fa-times</v-icon>
      </v-btn>
      <h1 class="text-center mb-12 pink--text">聯絡我們</h1>
      <p>Email: pnbhouse.customer@gmail.com</p><br>
      <p>line@: @420iuzxl</p>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false
    }
  }
}
</script>

<style lang="scss">
.aboutUs {
  .v-card {
    padding: 40px;
    min-height: 300px;
    p {
        color: black !important;
    }
    h4 {
        color: $main;
    }
    a {
        color: $main !important;
    }
  }
}
</style>